"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _styles = require("@mui/material/styles");
var _LiveHelpOutlined = _interopRequireDefault(require("@mui/icons-material/LiveHelpOutlined"));
var _ResourceHtml = _interopRequireDefault(require("./ResourceHtml"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ICON_SPACING = 0.25;
const TOOLTIP_MAX_WIDTH = 400;
const ARROW_COLOR = '#dadde9';
const StyledIconButton = (0, _styles.styled)(_IconButton.default, {
  shouldForwardProp: prop => prop !== 'white'
})(_ref => {
  let {
    theme,
    white
  } = _ref;
  return {
    marginRight: theme.spacing(ICON_SPACING),
    marginLeft: theme.spacing(ICON_SPACING),
    padding: 0,
    color: white ? '#ffffff' : theme.palette.secondary.main,
    height: '1em'
  };
});

/**
 * @classdesc ヒントマークとヒントコンテンツを表示する部品.
 * @prop {string} hint - ヒントコンテンツのid。
 * @prop {boolean} [white] - アイコンを白文字にする。
 */
class HintMark extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleTooltipOpen", function () {
      this.setState({
        hintOpen: true
      });
    });
    _defineProperty(this, "handleTooltipClose", function () {
      this.setState({
        hintOpen: false
      });
    });
    this.state = {
      hintOpen: false
    };
    this.handleTooltipOpen = this.handleTooltipOpen.bind(this);
    this.handleTooltipClose = this.handleTooltipClose.bind(this);
  }
  render() {
    const {
      hint,
      white,
      className
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
      onClickAway: this.handleTooltipClose
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      arrow: true,
      open: this.state.hintOpen,
      disableFocusListener: true,
      disableHoverListener: true,
      disableTouchListener: true,
      disableInteractive: false,
      className: className,
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: hint
      })),
      placement: "top",
      slotProps: {
        tooltip: {
          sx: {
            backgroundColor: '#ffffff',
            color: 'rgba(0, 0, 0, 1)',
            maxWidth: TOOLTIP_MAX_WIDTH,
            fontSize: '12px',
            border: '1px solid #aaaaaa',
            boxShadow: 1,
            '& b': {
              fontWeight: '500'
            }
          }
        },
        arrow: {
          sx: {
            color: ARROW_COLOR
          }
        }
      }
    }, /*#__PURE__*/_react.default.createElement(StyledIconButton, {
      onClick: this.handleTooltipOpen,
      white: white
    }, /*#__PURE__*/_react.default.createElement(_LiveHelpOutlined.default, null))));
  }
}
HintMark.propTypes = {
  hint: _propTypes.default.string.isRequired
};
var _default = exports.default = HintMark;